import React from "react";
import { Button, Container, Header } from "semantic-ui-react";
import { Link } from "react-router-dom";

function HomepageHeading({ mobile }) {
  return (
    <Container text>
      <Header
        as="h1"
        content="Lunde Water, LLC"
        inverted
        style={{
          fontSize: mobile ? "2em" : "3em",
          fontWeight: "normal",
          marginBottom: 0,
          // marginTop: mobile ? "1.5em" : "3em",
        }}
      />
      <Header
        as="h2"
        content="Your Premium Water Hauler"
        inverted
        style={{
          fontSize: mobile ? "1.3em" : "1.5em",
          fontWeight: "normal",
          // marginTop: mobile ? "0.5em" : "1.5em",
        }}
      />
      <Button
        as={Link}
        to="/water-quality"
        primary
        size={mobile ? "large" : "huge"}
        style={{ marginTop: "1.5em", backgroundColor: "#2185d0" }}
      >
        Learn About Our Water
      </Button>
    </Container>
  );
}

export default HomepageHeading;
